function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.79 4.78748C21.35 4.03748 20.39 3.77748 19.63 4.20748L15.44 6.62748L9.48 4.43748C7.84 3.83748 6.03 3.98748 4.52 4.85748L2.8 5.84748L11.34 8.98748L6.18 11.9675L4.29 11.2675L2 12.5875L5.82 13.9875L5.13 17.9975L7.42 16.6775L7.76 14.6975L12.92 11.7175L11.37 20.6875L13.09 19.6975C14.6 18.8275 15.64 17.3375 15.94 15.6175L17.02 9.35748L21.21 6.93748C21.96 6.49748 22.22 5.53748 21.79 4.77748V4.78748Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Airplane.js.map